<template>
  <div class="q-ml-md q-mr-md">
    <!-- Add a search input -->
    <q-input 
      v-model="search" 
      :placeholder="searchPlaceholder" 
      outlined 
      dense 
      class="q-mb-md"
    />

    <q-table
      :rows="rows"
      :columns="columns"
      row-key="id"
      v-model:pagination="pagination"
      :filter="search"
      dense
      flat
      bordered
    >
      <!-- Slot for customizable actions -->
      <template v-slot:body-cell-actions="props">
        <slot name="actions" :row="props.row">
          <q-td :props="props">
            <q-btn
              size="xs"
              color="primary"
              icon="edit"
              @click="onEdit(props.row)"
            />
          </q-td>
        </slot>
      </template>
    </q-table>

  </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    rows: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    totalRows: {
      type: Number,
      required: true
    },
    getEditUrl: {
      type: Function,
      required: false
    },
    searchPlaceholder: {
      type: String,
      default: "Search..."
    }
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: this.paginate ? 100 : 0
      },
      search: '', // Add search input binding
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalRows / this.pagination.rowsPerPage);
    }
  },
  methods: {
    onEdit(row) {
      const editUrl = this.getEditUrl ? this.getEditUrl(row) : null;
      if (editUrl) {
        this.$router.push(editUrl);
      }
    }
  }
};
</script>

<style scoped>
.q-table {
  margin-bottom: 1em;
}
</style>
